import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppSharedFacade, NodeSharedFacade } from '@medsurf/flat-facades';
import { MediaControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-grid',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss'],
    standalone: false
})
export class GridComponent {
  /**
   * Constructor
   *
   * @param appSharedFacade
   * @param nodeSharedFacade
   * @param mediaControlService
   */
  public constructor(public appSharedFacade: AppSharedFacade,
                     public nodeSharedFacade: NodeSharedFacade,
                     public mediaControlService: MediaControlService) {
  }
}
